module.exports = __webpack_public_path__ + "media/images/icons/spreadsheet-d2c8c34589e18a9a6c8b755496f81c7b.svg";